import type { FunctionComponent } from 'react'

import {
  FreeMembershipBenefitsPanel,
  type FreeMembershipBenefitsPanelProps,
} from './FreeMembershipBenefitsPanel'
import { useShouldShowFreeMembershipBenefitsPanel } from './hooks/useShouldShowFreeMembershipBenefitsPanel'

export const ArticleFreeMembershipBenefitsPanel: FunctionComponent<
  FreeMembershipBenefitsPanelProps
> = ({ placement = 'desktop', fullWidth = false, desktopBreakpoint = 1024 }) => {
  const shouldShow = useShouldShowFreeMembershipBenefitsPanel()

  if (!shouldShow) {
    return null
  }

  return (
    <FreeMembershipBenefitsPanel
      placement={placement}
      fullWidth={fullWidth}
      desktopBreakpoint={desktopBreakpoint}
    />
  )
}
